import { createFileRoute } from "@tanstack/react-router";
import { VendorTicketingPage } from "@/components/vendor/ticketing/VendorTicketingPage";

export const Route = createFileRoute("/vendor/ticketing")({
  head: () => ({ meta: [{ title: "Ticketing · Venue Portal" }] }),
  component: VendorTicketingPage,
});
